import React, { FC } from 'react';
import { flushSync } from 'react-dom';
import { createRoot } from 'react-dom/client';

import { Group, MantineProvider, Stack, Text, ThemeIcon } from '@mantine/core';
import { FLOWS, FlowType } from 'src/frontend/constants/GettingStartedFlows';

import { theme } from 'components/styles/theme';

const TourBadge: FC<{ tour: FlowType }> = ({ tour }) => {
    const flow = FLOWS[tour];

    return (
        <Group gap="sm" wrap="nowrap">
            <ThemeIcon color={flow.color} size="lg" radius={99} variant="light" fz={18}>
                {flow.icon}
            </ThemeIcon>
            <Stack gap={0}>
                <Text size="xs" c="dimmed">
                    Following tour
                </Text>
                <Text size="sm" fw={600}>
                    {flow.title}
                </Text>
            </Stack>
        </Group>
    );
};

const mountTourBadge = (tour: FlowType, container: HTMLElement) => {
    const root = createRoot(container);

    // Synchronous, as driver.js positions the popover right after the render hook returns and needs
    // the badge to already be part of its measured size.
    flushSync(() => {
        root.render(
            <MantineProvider theme={theme} withCssVariables={false} getRootElement={() => container}>
                <TourBadge tour={tour} />
            </MantineProvider>,
        );
    });

    return () => queueMicrotask(() => root.unmount());
};

export { TourBadge, mountTourBadge };
